import { render, staticRenderFns } from "./copy-order.vue?vue&type=template&id=d06ba8be&scoped=true"
import script from "./copy-order.vue?vue&type=script&lang=js"
export * from "./copy-order.vue?vue&type=script&lang=js"
import style0 from "./copy-order.vue?vue&type=style&index=0&id=d06ba8be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06ba8be",
  null
  
)

export default component.exports